<template>
    <v-container >
        <v-row >
            <v-col class="justify-center text-center col-7">
                <v-card class="mx-auto">
                    <v-card-text>
                        <v-row class="align-center">
                        <v-col>
                            <v-icon :size="56">mdi-circle-slice-8</v-icon>
                        </v-col>
                        <v-col>
                            <v-card outlined class="pa-8"></v-card>
                        </v-col>
                        <v-col>
                            <v-icon :size="56">mdi-circle-slice-8</v-icon>
                        </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text>
                        <v-row>
                        <v-col><v-btn class="px-8 py-6 col-3">1</v-btn></v-col>
                        <v-spacer class="col-3"/>
                        <v-col><v-btn class="px-8 py-6 col-3">2</v-btn></v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text>
                        <v-row>
                        <v-col><v-btn class="px-8 py-6 col-3">3</v-btn></v-col>
                        <v-spacer class="col-3"/>
                        <v-col><v-btn class="px-8 py-6 col-3">4</v-btn></v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="justify-center text-center col-5">
                <v-card class="mx-auto">
                    <v-card-text class="justify-center"><v-btn class="px-16 py-8">1</v-btn></v-card-text>
                    <v-card-text class="justify-center"><v-btn class="px-16 py-8">2</v-btn></v-card-text>
                    <v-card-text class="justify-center"><v-btn class="px-16 py-8">3</v-btn></v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>  
</template>
<script>
//import Remote from '@/views/Remote'
export default {
    name:"Ob",
    data(){
        return {
        }
    },
    props:['mms','mmsReady'],
    mixins:[],
    watch:{
        mmsReady(val){
            console.log(val);
        }
    },
    methods:{
    }
}
</script>